import React, { useMemo } from "react";
import translate from "../../i18n/translate";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { Box } from "@mui/material";
import SetHomePageButton from "../common/SetHomePageButton";
import { useIsAdmin } from "../../shared/hooks/ppHooks";

const ReportHeader = React.memo(({ isDarktheme }) => {
  const history = useHistory().location.pathname;
  const { isAdmin } = useIsAdmin();
  
  const boxSx = useMemo(() => ({
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: { xs: "flex-start", sm: "space-around" },
    alignItems: { xs: "flex-start", sm: "center" },
    background: !isDarktheme ? "#f1f1f1" : "#242526",
  }), [isDarktheme]);

  return (
    <div className={!isDarktheme ? "card" : "dark-card"}>
      <Box className="mb-2" sx={boxSx}>
        <SetHomePageButton 
          currentPath="/report"
          pageName="Report"
          variant="icon"
        />
        <label htmlFor="inputEmail3" className=" col-form-label">
          <Link
            to="report"
            className={`semi-nav ${history === "/report" && "active-semi"} m-4`}
          >
            {translate("sales")}
          </Link>
        </label>
        <label htmlFor="inputEmail3" className=" col-form-label">
          <Link
            to="profit"
            className={`semi-nav ${history === "/profit" && "active-semi"} m-0`}
          >
            {translate("profit_calculation")}
          </Link>
        </label>
        <label htmlFor="inputEmail3" className="col-form-label">
          <Link
            to="running"
            className={`semi-nav ${history === "/running" && "active-semi"}`}
          >
            {translate("running_balance")}
          </Link>
        </label>
        <label htmlFor="inputEmail3" className=" col-form-label">
          <Link
            to="credit_report"
            className={`semi-nav ${
              history === "/credit_report" && "active-semi"
            }`}
          >
            {translate("credits_report")}
          </Link>
        </label>
        <label htmlFor="inputEmail3" className=" col-form-label">
          <Link
            to="points"
            className={`semi-nav ${history === "/points" && "active-semi"}`}
          >
            {translate("points")}
          </Link>
        </label>
        <label htmlFor="inputEmail3" className=" col-form-label">
          <Link
            to="debit_report"
            className={`semi-nav ${
              history === "/debit_report" && "active-semi"
            }`}
          >
            {translate("debit_report")}
          </Link>
        </label>
        {isAdmin && (
          <label htmlFor="inputEmail3" className=" col-form-label">
            <Link
              to="live_log"
              className={`semi-nav ${
                history === "/live_log" && "active-semi"
              }`}
            >
              {translate("live_log")}
            </Link>
          </label>
        )}

        {/* No toggles here anymore; moved to table header */}
      </Box>
    </div>
  );
});

ReportHeader.displayName = 'ReportHeader';

const mapStateToProps = ({ darkTheme: { isDarktheme } }) => ({
  isDarktheme,
});

export default connect(mapStateToProps, null)(ReportHeader);
